import React, { useCallback, useState } from 'react';
import { Toast, ToastData, ToastType } from './Toast';
import { ToastContext } from '@/contexts/ToastContext';

interface ToastProviderProps {
  children: React.ReactNode;
}

let toastCounter = 0;

/**
 * Toast Provider
 * Manages a queue of toast notifications and renders them.
 * Bottom-center on mobile, top-right on desktop.
 */
export const ToastProvider: React.FC<ToastProviderProps> = ({ children }) => {
  const [toasts, setToasts] = useState<ToastData[]>([]);

  const showToast = useCallback((message: string, type: ToastType) => {
    const id = `toast-${++toastCounter}`;
    setToasts((prev) => [...prev, { id, message, type }]);
  }, []);

  const dismissToast = useCallback((id: string) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {/* Toast container: bottom-center on mobile, top-right on desktop */}
      {toasts.length > 0 && (
        <div
          className="fixed z-50 flex flex-col gap-2
            bottom-4 left-1/2 -translate-x-1/2
            md:bottom-auto md:top-4 md:right-4 md:left-auto md:translate-x-0"
        >
          {toasts.map((toast) => (
            <Toast key={toast.id} toast={toast} onDismiss={dismissToast} />
          ))}
        </div>
      )}
    </ToastContext.Provider>
  );
};
